import { render, staticRenderFns } from "./BssLogDetail.vue?vue&type=template&id=5874740e&scoped=true"
import script from "./BssLogDetail.vue?vue&type=script&lang=js"
export * from "./BssLogDetail.vue?vue&type=script&lang=js"
import style0 from "./BssLogDetail.vue?vue&type=style&index=0&id=5874740e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874740e",
  null
  
)

export default component.exports